import React from 'react';
import { motion } from 'framer-motion';
import './Services.css';
// Using beauty salon images from Unsplash instead of local car images

const Services = () => {
  const services = [
    {
      icon: 'fas fa-user-friends',
      title: 'Frontal Installation',
      description: 'Professional frontal lace wig installation for a natural, seamless look that enhances your beauty.',
      image: 'https://images.unsplash.com/photo-1560066984-138dadb4c035?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
    },
    {
      icon: 'fas fa-braid',
      title: 'Braids & Styling',
      description: 'Expert braiding services including box braids, cornrows, and creative protective styles.',
      image: 'https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
    },
    {
      icon: 'fas fa-magic',
      title: 'Hair Revamping',
      description: 'Complete hair transformation services to refresh and revitalize your natural hair.',
      image: 'https://images.unsplash.com/photo-1562322140-8baeececf3df?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
    },
    {
      icon: 'fas fa-crown',
      title: 'Wigging Services',
      description: 'Professional wig styling, maintenance, and custom wig creation for all occasions.',
      image: 'https://images.unsplash.com/photo-1580618672591-eb180b1a973f?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
    },
    {
      icon: 'fas fa-hand-sparkles',
      title: 'Nails & Manicure',
      description: 'Professional nail care including manicures, pedicures, and creative nail art designs.',
      image: 'https://images.unsplash.com/photo-1604654894610-df63bc536371?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
    },
    {
      icon: 'fas fa-spa',
      title: 'Head Massage & Wellness',
      description: 'Relaxing head massage therapy to promote hair growth and overall wellness.',
      image: 'https://images.unsplash.com/photo-1544161515-4ab6ce6db874?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
    }
  ];

  return (
    <section id="services" className="services section">
      <div className="container">
        <div className="section-header text-center mb-4">
          <h2>Our Beauty Services</h2>
          <p>Professional beauty and wellness services designed to enhance your natural beauty</p>
        </div>
        
        <div className="services-grid grid grid-3">
          {services.map((service, index) => (
            <motion.div 
              key={index} 
              className="service-card card"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.6 }}
              whileHover={{ y: -10, scale: 1.02 }}
            >
              <div className="service-image">
                <img src={service.image} alt={service.title} />
                <div className="service-overlay">
                  <motion.div 
                    className="service-icon"
                    whileHover={{ scale: 1.2, rotate: 360 }}
                    transition={{ duration: 0.3 }}
                  >
                    <i className={service.icon}></i>
                  </motion.div>
                </div>
              </div>
              <div className="service-content">
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;